export default __webpack_public_path__ + "static/071-3f7fe60f77c0c5c6fe3147fa15cd7e58.jpg";